/**
 * Walk-in waitlist (calendar redesign ticket 4). Backend: bookings-infra
 * walk-in waitlist stack (core service, staff auth). See
 * docs/WALK_IN_WAITLIST.md.
 */

/** Customer comments limit (lands in transactions.customer_notes on assign). */
export const MAX_WALK_IN_COMMENTS_LENGTH = 500;

/** One waiting row, as GET / POST / PUT return it. */
export interface WaitlistEntry {
  uuid: string;
  client_uuid: string;
  client_first_name: string;
  client_last_name: string;
  salon_service_uuid: string;
  service_name: string;
  service_duration_mins: number;
  comments: string | null;
  /** ISO UTC. */
  arrived_at: string;
  position: number;
  /** "staff" | "walk_in_portal". */
  source: string;
  /**
   * Provider the client asked for on the walk-in portal (staff_users id =
   * calendar Employee.id); preselected in the assign picker.
   */
  preferred_staff_id: string | null;
  preferred_staff_name: string | null;
}

export interface CreateWaitlistEntryRequest {
  client_uuid: string;
  salon_service_uuid: string;
  comments?: string;
}

/** Partial: only the changed fields. */
export type UpdateWaitlistEntryRequest = Partial<CreateWaitlistEntryRequest>;

export interface AssignWaitlistEntryRequest {
  /** servicing_staff entry id (same value as booked_services[].staff_service_id). */
  staff_service_id: string;
  /** ISO UTC. */
  start_dt: string;
  /** Picked via "Any available": the appointment is marked like an online
   *  Any Available booking (the calendar's ANY marker). Default false. */
  booked_using_any_available?: boolean;
}

export interface AssignWaitlistEntryResponse {
  transaction_uuid: string;
  waitlist_uuid: string;
  [key: string]: unknown;
}

/** Pusher `waitlist.sync` payload (private-salon-{id}-notifications). */
export interface WaitlistSyncEvent {
  action: string;
  waitlist_uuid?: string;
  session_id?: string | null;
}

/** As held in NotificationContext's bounded buffer (seq = arrival order). */
export interface SequencedWaitlistSyncEvent extends WaitlistSyncEvent {
  seq: number;
}
